import { render } from "./RegisteredItemsList.vue?vue&type=template&id=ed90f056"
import script from "./RegisteredItemsList.vue?vue&type=script&lang=js"
export * from "./RegisteredItemsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__